import React, { ReactNode } from "react";
import { useAppSelector } from "../../hooks";

interface Props {
    children: ReactNode;
}
const Wrapper: React.FC<Props> = ({
    children
}) => {
    const isOpen = useAppSelector(state => state.loginLayer.isOpen);
    return (
        <div id="layer_login" className="layer" style={{display: isOpen? "block" : "none"}}>
            <div className="middle">
                {children}
            </div>
            <div className="blockui"></div>
        </div>
    )
}

export default Wrapper;